import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { submitContact, resetContact } from '../lib/actions/contactActions';

const initialState = {
  nom: '', prenom: '', email: '', role: '',
  entreprise: '', siteWeb: '',
  taille: '', ca: '', budget: '',
  service: '', message: '',
};

export default function ContactForm() {
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector((state) => state.contact);
  const [form, setForm] = useState(initialState);

  const set = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  useEffect(() => {
    if (success) {
      setForm(initialState);
      const timer = setTimeout(() => dispatch(resetContact()), 5000);
      return () => clearTimeout(timer);
    }
  }, [success, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(submitContact({
      lastName: form.nom,
      firstName: form.prenom,
      mail: form.email,
      role: form.role,
      companyName: form.entreprise,
      companyWebsite: form.siteWeb,
      companySize: form.taille,
      annualCa: form.ca,
      budget: form.budget,
      interestedService: form.service,
      description: form.message,
    }));
  };

  return (
    <section className="contact-section" id="contact">
      <div className="blobs" style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
        <div className="blob blob-2" style={{ opacity: .15 }} />
        <div className="blob blob-3" style={{ opacity: .15 }} />
      </div>

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1200, margin: '0 auto' }}>
        <div className="section-header center" style={{ marginBottom: 48 }}>
          <span className="section-label">Parlons de votre projet</span>
          <h2 className="section-title">Prêt à passer à l'IA ?</h2>
          <p className="section-sub" style={{ margin: '0 auto' }}>
            Remplissez ce formulaire et nous vous contacterons sous 24h pour un audit gratuit.
          </p>
        </div>

        <div className="contact-wrap">
          {success && (
            <div className="form-feedback form-feedback--success">
              ✅ Merci ! Votre demande a bien été envoyée. Nous vous recontactons sous 24h.
            </div>
          )}
          {error && (
            <div className="form-feedback form-feedback--error">
              ❌ {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group">
                <label>Nom<span className="req">*</span></label>
                <input name="nom" value={form.nom} onChange={set} placeholder="Votre nom" required />
              </div>
              <div className="form-group">
                <label>Prénom<span className="req">*</span></label>
                <input name="prenom" value={form.prenom} onChange={set} placeholder="Votre prénom" required />
              </div>
              <div className="form-group">
                <label>Quelle est votre adresse e-mail ?<span className="req">*</span></label>
                <input type="email" name="email" value={form.email} onChange={set} placeholder="E-mail" required />
              </div>
              <div className="form-group col-full">
                <label>Quel est votre rôle dans l'entreprise ?<span className="req">*</span></label>
                <input name="role" value={form.role} onChange={set} placeholder="Saisissez votre rôle" required />
              </div>
              <div className="form-group">
                <label>Nom Entreprise<span className="req">*</span></label>
                <input name="entreprise" value={form.entreprise} onChange={set} placeholder="Saisissez le nom de l'entreprise" required />
              </div>
              <div className="form-group">
                <label>Site web Entreprise<span className="req">*</span></label>
                <input name="siteWeb" value={form.siteWeb} onChange={set} placeholder="Saisissez le site web de l'entreprise" required />
              </div>
              <div className="form-group">
                <label>Taille de l'entreprise<span className="req">*</span></label>
                <select name="taille" value={form.taille} onChange={set} required>
                  <option value="">Sélectionnez la taille de l'entreprise</option>
                  <option>1 – 10 employés</option>
                  <option>11 – 50 employés</option>
                  <option>51 – 200 employés</option>
                  <option>201 – 500 employés</option>
                  <option>500+ employés</option>
                </select>
              </div>
              <div className="form-group">
                <label>Chiffre d'affaires annuel<span className="req">*</span></label>
                <select name="ca" value={form.ca} onChange={set} required>
                  <option value="">Sélectionnez une fourchette de revenus</option>
                  <option>Moins de 100 000 €</option>
                  <option>100 000 € – 500 000 €</option>
                  <option>500 000 € – 1 M€</option>
                  <option>1 M€ – 5 M€</option>
                  <option>Plus de 5 M€</option>
                </select>
              </div>
              <div className="form-group">
                <label>Budget du projet<span className="req">*</span></label>
                <select name="budget" value={form.budget} onChange={set} required>
                  <option value="">Sélectionnez votre budget</option>
                  <option>Moins de 5 000 €</option>
                  <option>5 000 € – 10 000 €</option>
                  <option>10 000 € – 25 000 €</option>
                  <option>25 000 € – 50 000 €</option>
                  <option>Plus de 50 000 €</option>
                </select>
              </div>
              <div className="form-group">
                <label>Quels services vous intéressent ?<span className="req">*</span></label>
                <select name="service" value={form.service} onChange={set} required>
                  <option value="">Sélectionnez un service</option>
                  <option>Identifier les opportunités IA</option>
                  <option>Former votre équipe à l'IA</option>
                  <option>Développer des solutions IA sur mesure</option>
                  <option>Intégrer un "Référent IA"</option>
                </select>
              </div>
              <div className="form-group col-full">
                <label>Décrivez votre projet</label>
                <textarea name="message" value={form.message} onChange={set} placeholder="Partagez le contexte, vos objectifs, vos contraintes…" />
              </div>
            </div>
            <div className="form-submit">
              <button type="submit" disabled={loading}>
                {loading ? 'Envoi en cours…' : 'Envoyer ma demande →'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
